import React from 'react'

import { Formik } from 'formik'
import * as yup from 'yup'
import CustomerConfigFormFields from './CustomerConfigFormFields'

const CustomerConfigForm = ({ submitUserInfo, components }) => {
  yup.addMethod(yup.object, 'transformToObject', function() {
    return this.transform(function(value, originalValue) {
      if (this.isType(value)) return value
      return { editable: false, required: false, external: false }
    })
  })

  let schema = yup.object().shape({
    components: yup.array().of(
      yup.object().shape({
        DocumentParameters: yup.array().of(
          yup.object().shape({
            Description: yup.object().transformToObject(),
            value: yup.string().when('Description', {
              is: Description =>
                Description.required &&
                Description.external &&
                Description.editable,
              then: yup.string().required()
            })
          })
        )
      })
    )
  })
  return (
    <Formik
      initialValues={{ components: components }}
      onSubmit={submitUserInfo}
      validationSchema={schema}
    >
      {props => <CustomerConfigFormFields {...props} />}
    </Formik>
  )
}

export default CustomerConfigForm
